import { useState, useEffect } from 'react'
import { Monitor, MapPin } from 'lucide-react'
import { getAdminDisplays } from '../../lib/api'

export default function AdminDisplays() {
  const [displays, setDisplays] = useState([])
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    getAdminDisplays().then(data => { setDisplays(data || []); setLoading(false) })
      .catch(() => {
        setDisplays([
          { id: 'disp_001', name: 'Living Room TV', mode: 'matrix', user_email: 'user1@example.com', active: true, last_seen: '2 min ago', location: 'London, UK' },
          { id: 'disp_002', name: 'Office Monitor', mode: 'dashboard', user_email: 'user2@example.com', active: true, last_seen: '5 min ago', location: 'Manchester, UK' },
        ])
        setLoading(false)
      })
  }, [])
  
  if (loading) return <div className="p-8 flex items-center justify-center h-full"><div className="w-8 h-8 border-2 border-flight-cyan border-t-transparent rounded-full animate-spin" /></div>
  
  return (
    <div className="p-8">
      <div className="mb-8"><h1 className="text-2xl font-bold text-white">Displays</h1><p className="text-slate-400 text-sm">Monitor all active displays</p></div>
      <div className="glass-panel overflow-hidden">
        <table className="w-full">
          <thead><tr className="border-b border-slate-700">
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Display</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Owner</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Mode</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Status</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Location</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Last Seen</th>
          </tr></thead>
          <tbody>
            {displays.map(d => (
              <tr key={d.id} className="border-b border-slate-800/50 hover:bg-slate-800/20">
                <td className="p-4"><div className="flex items-center gap-3"><div className="w-8 h-8 rounded-lg bg-slate-800 flex items-center justify-center"><Monitor className="w-4 h-4 text-slate-400" /></div><div><div className="text-white text-sm font-medium">{d.name}</div><div className="text-slate-500 text-xs font-mono">{d.id}</div></div></div></td>
                <td className="p-4 text-slate-300 text-sm">{d.user_email}</td>
                <td className="p-4"><span className="text-xs font-medium capitalize text-flight-cyan">{d.mode}</span></td>
                <td className="p-4"><span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${d.active ? 'bg-emerald-500/10 text-emerald-400' : 'bg-slate-700 text-slate-400'}`}><span className={`w-1.5 h-1.5 rounded-full ${d.active ? 'bg-emerald-400' : 'bg-slate-500'}`} />{d.active ? 'Online' : 'Offline'}</span></td>
                <td className="p-4 text-slate-400 text-sm flex items-center gap-1"><MapPin className="w-3 h-3" />{d.location}</td>
                <td className="p-4 text-slate-400 text-sm">{d.last_seen}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
